import { createReducer, on } from '@ngrx/store';
import { SessionActions } from './session.actions';
import { SessionState, initialState } from './session.state';

export const reducer = createReducer(
  initialState,
  on(SessionActions.login_start, SessionActions.get_user_start, (state: SessionState) => ({
    ...state,
    loading: true,
    error: null,
    user: null
  })),
  on(SessionActions.login_success, SessionActions.get_user_success, (state: SessionState, data) => {
    let fixedLocale = '';
    if (data.user.UILanguage === 'en') {
      fixedLocale = 'en-GB';
    } else if (data.user.UILanguage === 'nn-NO') {
      fixedLocale = 'no';
    } else {
      fixedLocale = data.user.UILanguage;
    }
    return {
      ...state,
      loading: false,
      error: null,
      user: data.user,
      UILocale: fixedLocale
    };
  }),
  on(SessionActions.login_fail, (state: SessionState, error) => ({
    ...state,
    loading: false,
    error,
    user: null
  })),
  on(SessionActions.get_user_fail, (state: SessionState, error) => {
    return {
      ...state,
      loading: false,
      error,
      user: null
    };
  }),
  on(SessionActions.logout, (state: SessionState) => ({
    ...state,
    user: null
  })),
  on(SessionActions.no_op, (state: SessionState) => ({
    ...state
  }))
);
